export const COLORS = {
  primary: '#081210',
  secondary: '#081210',
  primaryLight: '#E6E7E7',
  neutral: '#8D9291',
  fontColor: '#333333',
  dark: '#333333',
  Secondary600: "#3B9C8D",
  gray: {
    50: '#EEEEEE',
    100: '#F8F8F8',
    200: '#F2F2F2',
    300: '#D9D9D9',
    400: '#C4C4C4',
    500: '#8D8D8D',
    700: '#454545',
  },
  danger: {
    200: '#FFF4F4',
    300: '#FCB4B4',
    600: '#E83B3B',
  },
};
